import axios from "axios";
import config from "../../helpers/config";
import instance from "../../helpers/AxiosInterceptor";


export const downloadTemp = async () => {
    return await axios.get(`${config.baseURL}/client/template/download`,
        {
            headers: {
                "Authorization": "Bearer " + JSON.parse(localStorage.getItem("authUser")).accessToken
            }
        })
};

export const uploadData = async (formData) => {
    let headers = { "Content-type": "multipart/form-data", "Authorization": "Bearer " + JSON.parse(localStorage.getItem("authUser")).accessToken }
    return await axios.post(`${config.baseURL}/client/upload`, formData, { headers: headers });
};

export const search = (query) => {
    return instance.post(`/client/search`, JSON.stringify(query));
};



export const find = (id) => {
    return instance.get(`/client/find/${id}`);
};

export const create = (request) => {
    return instance.post(`/client/create`, JSON.stringify(request));
};


export const deleteRec = (id) => {
    return instance.delete(`/client/delete/${id}`);
};
